import { type AccountData, type SourceFormat } from '../models'

import { canParseFullFormat, parseFullFormat, splitFullFormatRecords } from './full-format'
import { canParseMobile, parseMobile, splitMobileRecords } from './mobile'
import { canParseNetscape, parseNetscape, splitNetscapeRecords } from './netscape'
import { canParsePipe, parsePipe, splitPipeRecords } from './pipe'
import { canParseWebBlocks, parseWebBlocks, splitWebBlocksRecords } from './web-blocks'
import { canParseWebCookies, parseWebCookies, splitWebCookiesRecords } from './web-cookies'
import { canParseWebJson, parseWebJson, splitWebJsonRecords } from './web-json'

export type ParserFns = {
  splitRecords: (data: string) => string[]
  parse: (record: string) => AccountData
  canParse: (data: string) => boolean
}

export const PARSERS: Record<SourceFormat, ParserFns> = {
  full_format: {
    splitRecords: splitFullFormatRecords,
    parse: parseFullFormat,
    canParse: canParseFullFormat,
  },
  web_cookies: {
    splitRecords: splitWebCookiesRecords,
    parse: parseWebCookies,
    canParse: canParseWebCookies,
  },
  web_blocks: {
    splitRecords: splitWebBlocksRecords,
    parse: parseWebBlocks,
    canParse: canParseWebBlocks,
  },
  web_json: {
    splitRecords: splitWebJsonRecords,
    parse: parseWebJson,
    canParse: canParseWebJson,
  },
  mobile: {
    splitRecords: splitMobileRecords,
    parse: parseMobile,
    canParse: canParseMobile,
  },
  pipe: {
    splitRecords: splitPipeRecords,
    parse: parsePipe,
    canParse: canParsePipe,
  },
  netscape: {
    splitRecords: splitNetscapeRecords,
    parse: parseNetscape,
    canParse: canParseNetscape,
  },
}

export const PARSER_NAMES: SourceFormat[] = [
  'full_format',
  'web_cookies',
  'web_blocks',
  'web_json',
  'mobile',
  'pipe',
  'netscape',
]
